import React from "react";
import styles from "./FlausLandingScreen.module.css";

const FlausLandingScreen = ({ businessLogo, onFlausWebsite, onOther }) => {
  return (
    <div className={styles.container}>
      {/* Logo — larger than standard portal */}
      {businessLogo && (
        <img
          src={`${process.env.PUBLIC_URL}/business_images/${businessLogo}`}
          alt="Flaus"
          className={styles.logo}
        />
      )}

      {/* Card container — question + options + labels */}
      <div className={styles.selection_card}>
        <p className={styles.question}>Where did you buy your Flosser?</p>

        <div className={styles.cards_row}>
          {/* Left card — Flaus Website */}
          <div className={styles.card_wrapper} onClick={onFlausWebsite}>
            <div className={styles.card}>
              <img
                src={`${process.env.PUBLIC_URL}/images/flaus_tooth.png`}
                alt="Flaus tooth"
                className={styles.tooth_img}
              />
            </div>
            <p className={styles.card_label}>Flaus Website</p>
          </div>

          {/* Right card — Other retailers */}
          <div className={styles.card_wrapper} onClick={onOther}>
            <div className={styles.card}>
              <div className={styles.retailer_grid}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/flaus_amazon_logo.png`}
                  alt="Amazon"
                  className={styles.amazon_logo}
                />
                <div className={styles.retailer_right}>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/flaus_gma_logo.png`}
                    alt="Good Morning America"
                    className={styles.small_logo}
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/images/flaus_qvc_logo.png`}
                    alt="QVC"
                    className={styles.small_logo}
                  />
                </div>
              </div>
            </div>
            <p className={styles.card_label}>Other</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlausLandingScreen;
